import { Flame, Zap, Truck, type LucideIcon } from 'lucide-react';

export const SCOPE_COLORS: Record<string, string> = {
  scope1: '#84cc16', // lime-500
  scope2: '#10b981', // emerald-500
  scope3: '#0f766e', // teal-700
};

export const SCOPE_BG_COLORS: Record<string, string> = {
  scope1: 'rgba(132, 204, 22, 0.1)',
  scope2: 'rgba(16, 185, 129, 0.1)',
  scope3: 'rgba(15, 118, 110, 0.1)',
};

export const SCOPE_FA_ICONS: Record<string, string> = {
  scope1: 'fa-fire',
  scope2: 'fa-bolt',
  scope3: 'fa-truck',
};

export const SCOPE_LUCIDE_ICONS: Record<string, LucideIcon> = {
  scope1: Flame,
  scope2: Zap,
  scope3: Truck,
};

export const SCOPE_TAILWIND: Record<string, { iconBg: string; icon: string; border: string; gradient: string }> = {
  scope1: { iconBg: 'tw:bg-lime-500/10',    icon: 'tw:text-lime-600',    border: 'lime-500',    gradient: 'tw:bg-gradient-to-br tw:to-blue-100/50 tw:from-lime-300/40' },
  scope2: { iconBg: 'tw:bg-emerald-500/10', icon: 'tw:text-emerald-500', border: 'emerald-500', gradient: 'tw:bg-gradient-to-br tw:to-blue-100/30 tw:from-emerald-500/30' },
  scope3: { iconBg: 'tw:bg-teal-700/10',    icon: 'tw:text-teal-700',    border: 'teal-700',    gradient: 'tw:bg-gradient-to-br tw:to-blue-100/50 tw:from-teal-300/40' },
};
